function configureProduct(root) {
  const selector = root.querySelector('[name=id]');
  const choices = Array.from(root.querySelectorAll('[data-option]'));
  const variants = Array.from(selector.options);
  const add = root.querySelector('[data-add]');
  const image = root.querySelector('#fc-gallery-image');
  function showImage(url, alt) {
    if (!image || !url) return;
    image.removeAttribute('srcset');
    image.src = url;
    if (alt) image.alt = alt;
  }
  function showVariant(variant) {
    add.disabled = !variant || variant.dataset.available !== 'true';
    add.textContent = add.disabled ? 'Sold out' : 'Add to cart';
    if (!variant) return;
    selector.value = variant.value;
    root.querySelector('[data-price]').textContent = variant.dataset.price;
    const previous = root.querySelector('[data-was]');
    previous.textContent = variant.dataset.was;
    previous.hidden = !variant.dataset.was;
    showImage(variant.dataset.image, root.querySelector('h1').textContent);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.value);
    history.replaceState(null, '', url);
  }
  if (choices.length) {
    const selected = JSON.parse(selector.selectedOptions[0].dataset.opts);
    choices.forEach((choice, i) => { choice.value = selected[i]; });
    root.querySelector('.fc-opts').hidden = false;
    choices.forEach(choice => choice.addEventListener('change', () => {
      const values = choices.map(input => input.value);
      showVariant(variants.find(v => JSON.parse(v.dataset.opts).every((opt,i) => opt === values[i])));
    }));
  }
  root.querySelector('.fc-combined').hidden = true;
  root.querySelectorAll('[data-image][data-alt]').forEach(button => {
    button.addEventListener('click', () => showImage(button.dataset.image, button.dataset.alt));
  });
}
document.querySelectorAll('[data-product]').forEach(configureProduct);
document.addEventListener('click', event => {
  const filter = event.target.closest('[data-filter]');
  if (filter) {
    const container = filter.closest('.fc-shopping');
    container.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
    container.querySelectorAll('[data-groups]').forEach(card => {
      card.hidden = filter.dataset.filter !== 'All' && !card.dataset.groups.split('|').includes(filter.dataset.filter);
    });
  }
  document.querySelectorAll('.fc-header details[open]').forEach(details => {
    if (!details.contains(event.target)) details.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.fc-header details[open]').forEach(details => {
    details.open = false;
    details.querySelector('summary').focus();
  });
});
function configureOffers(root) {
  const packSelect = Array.from(root.querySelectorAll('[data-option]')).find(select => select.dataset.name === 'Pack');
  if (!packSelect) return;
  const tiers = JSON.parse(root.querySelector('[data-offers]').textContent);
  if (!tiers.length) return;
  const allChoices = Array.from(root.querySelectorAll('[data-option]'));
  const options = allChoices.filter(select => select !== packSelect);
  const variants = Array.from(root.querySelector('[name=id]').options).map(option => ({option,values:JSON.parse(option.dataset.opts)}));
  const packPosition = allChoices.indexOf(packSelect);
  const fitOptions = [...new Set(variants.map(v => v.values.filter((_,i) => i !== packPosition).join(' / ')))].filter(Boolean);
  const holder = root.querySelector('[data-pack-fields]');
  const fieldset = document.createElement('fieldset');
  fieldset.className = 'fc-offers';
  const legend = document.createElement('legend');
  legend.textContent = 'BUNDLE & SAVE';
  const grid = document.createElement('div');
  grid.className = 'fc-offer-grid';
  fieldset.append(legend,grid);
  const fit = document.createElement('div');
  holder.append(fieldset,fit);
  const packLabel = packSelect.closest('label');
  packLabel.hidden = true;

  function extraSelect(title, choices, initial, previous) {
    const label = document.createElement('label');
    label.textContent = title;
    const input = document.createElement('select');
    input.name = 'properties[' + title + ']';
    for (const value of choices) input.add(new Option(value,value));
    if (choices.includes(previous || initial)) input.value = previous || initial;
    label.append(input);
    return label;
  }

  function refresh() {
    const old = Object.fromEntries(Array.from(fit.querySelectorAll('select')).map(input => [input.name,input.value]));
    fit.replaceChildren();
    grid.replaceChildren();
    const mainFit = options.map(input => input.value).join(' / ');
    const selected = tiers.find(tier => tier.title === packSelect.value);
    if (!selected) return;
    tiers.forEach(tier => {
      const candidate = variants.find(v => v.values[packPosition] === tier.title && v.values.every((value,i) => i === packPosition || value === allChoices[i].value));
      if (!candidate) return;
      const button = document.createElement('button');button.type = 'button';
      button.setAttribute('aria-pressed',String(tier === selected));
      button.disabled = candidate.option.dataset.available !== 'true';
      if (tier.label) { const badge=document.createElement('small');badge.textContent=tier.label;button.append(badge); }
      const indicator=document.createElement('i');indicator.textContent=tier===selected?'◉':'○';indicator.setAttribute('aria-hidden','true');
      const title=document.createElement('b');title.textContent=tier.title;
      const price=document.createElement('em');price.textContent=candidate.option.dataset.price;
      button.append(indicator,title,price);
      button.addEventListener('click',() => {packSelect.value=tier.title;packSelect.dispatchEvent(new Event('change',{bubbles:true}));});
      grid.append(button);
    });
    if (fitOptions.length > 1) {
      for (let n=2;n<=selected.count;n++) {
        const title='Item '+n+' fit';
        fit.append(extraSelect(title,fitOptions,mainFit,old['properties['+title+']']));
      }
    }
    for (const gift of selected.gifts) {
      for (let n=1;n<=gift.count;n++) {
        const title='Free '+gift.title+(gift.count>1?' '+n:'');
        fit.append(extraSelect(title,gift.options,mainFit,old['properties['+title+']']));
      }
    }
    fit.className=fit.children.length?'fc-fit':'';
    const badge=root.querySelector('[data-sale]');
    if(badge) {const text=root.querySelector('[name=id]').selectedOptions[0].dataset.sale;badge.textContent=text;badge.hidden=!text;}
  }
  allChoices.forEach(input=>input.addEventListener('change',refresh));
  refresh();
}
document.querySelectorAll('[data-product]').forEach(configureOffers);
document.querySelectorAll('.fc-filters [aria-pressed=true]').forEach(button=>button.click());
